import { versionConfig, statusConfig, regionConfig, languageConfig } from '../options.js';
import { CArticle } from '../../models/article.js';
const articleModel = new CArticle();
export const articles = {
    model: articleModel,
    type: 'articles',
    contentType: 'article',
    editor: 'html',
    editorTitle: { name: 'title', placeholder: 'title' },
    supportContent: ['articles'],
    documentProperty: 'content',
    title: 'Article',
    plural: 'Articles',
    endpoint: 'articles',
    version: versionConfig,
    listing: {
        type: 'grid',
        gridSupportContent: ['categories'],
        gridContentType: 'articles',
        gridCombineProperty: 'slug',
        gridDecode: ['title'],
        gridJoin: { properties: ['tags', 'categories', 'region', 'language'] },
        gridFormat: [
            // todo: move gridDecode into normalized gridFormat { format: 'decode', properties: ['title'] },
            { format: 'date', properties: ['created', 'modified'] },
        ],
        gridColumns: ['title', 'tags', 'categories', 'type', 'created', 'modified'],
        gridSearch: [{ key: 'title', combine: true }],
        gridHasChildren: true,
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            { label: 'Type', key: 'type', uppercase: true, default: true },
            { label: 'Category', key: 'categories', source: 'property', uppercase: true, default: true },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
        ],
    },
    queryProperties: [
        'id',
        'title',
        'slug',
        'status',
        'type',
        'client',
        'region',
        'language',
        'created',
        'modified',
        'tags',
        'categories',
    ],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
            { label: 'Author', name: 'author', input: 'select' },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
        category: [
            { label: 'Categories', name: 'categories', type: 'category' },
            { label: 'Curated Categories', name: 'curatedCategories', type: 'curatedCategory' },
        ],
        tag: [
            {
                label: 'Tags',
                name: 'tags',
                input: 'multiselect',
                type: 'standard',
                description: 'Type to search. Click dropdown entry to add tag. Click tag to remove.',
            },
            {
                label: 'Internal Tags',
                name: 'internalTags',
                input: 'multiselect',
                type: 'internal',
                description: 'Type to search. Click dropdown entry to add tag. Click tag to remove.',
            },
        ],
        images: [
            { label: 'Featured Image', name: 'image' },
            { label: 'V3 Featured Image', name: 'v3image' },
        ],
    },
    objectList: {
        biteSized: {
            label: 'Bite Sized',
            name: 'biteSized',
            description: 'Add entries for "Bite Sized" content',
            config: [
                { label: 'Pre Heading', name: 'preHeading', input: 'text' },
                { label: 'Heading', name: 'heading', input: 'html' },
                { label: 'Body', name: 'body', input: 'html' },
            ],
        },
        expertInsights: {
            label: 'Expert Insights',
            name: 'expertInsights',
            description: 'Add entries for Expert Insights',
            config: [
                {
                    label: 'Planner',
                    name: 'plannerId',
                    input: 'select',
                    options: { source: 'authors', value: 'id', label: 'name' },
                },
                {
                    label: 'Body',
                    name: 'body',
                    input: 'html',
                },
            ],
        },
    },
    meta: [
        {
            label: 'Excerpt',
            name: 'excerpt',
            input: 'textarea',
            description: 'Content Excerpt (displays in library index).',
        },
        {
            label: 'Content Type',
            name: 'type',
            input: 'select',
            description: 'Please select the content type.',
            options: [
                { label: 'Article', value: 'article' },
                { label: 'Video', value: 'video' },
                { label: 'User Stories', value: 'userStories' },
                { label: 'Planner Stories', value: 'plannerStories' },
                { label: 'Infographic', value: 'infographic' },
                { label: 'Expert Insights', value: 'expertInsights' },
                { label: 'Bite Sized', value: 'biteSized' },
                { label: 'Calculator', value: 'calculator' },
                { label: 'Downloadable', value: 'downloadable' },
                { label: 'Podcast', value: 'podcast' },
                { label: 'Quiz', value: 'quiz' },
                { label: 'Checklist', value: 'checklist' },
                { label: 'Blog', value: 'blog' },
            ],
        },
        {
            label: 'Notes',
            name: 'notes',
            input: 'textarea',
            description: 'Document notes.',
        },
        {
            label: 'Reference Link',
            name: 'referenceLink',
            input: 'text',
            description: 'Please enter the Reference Link for content types other than Articles and Blogs.',
        },
        {
            label: 'Mime Type',
            name: 'mimeType',
            input: 'select',
            description: 'Please select the content mime type.',
            options: [
                { label: 'HTML', value: 'text/html' },
                { label: 'PDF', value: 'application/pdf' },
                { label: '.DOC', value: 'application/msword' },
                { label: '.XLS .XLT .XLA', value: 'application/vnd.ms-excel' },
                {
                    label: '.PPT .POT .PPS .PPA',
                    value: 'application/vnd.ms-powerpoint',
                },
            ],
        },
        {
            label: 'Priority',
            name: 'priority',
            input: 'number',
            description: 'Please enter the content priority number with 100 being the highest and 0 being the lowest.',
        },
        {
            label: 'Exclude Client',
            name: 'exclude',
            input: 'multiselect',
            description: 'Add clients to prevent them from viewing this article.',
        },
        {
            label: 'Show in Library',
            name: 'showInLibrary',
            input: 'select',
            description: 'Controls if this content should displayed in the library index (still allows for direct linking).',
            options: [
                { label: 'True', value: true },
                { label: 'False', value: false },
            ],
        },
        {
            label: 'Redirect',
            name: 'redirect',
            input: 'text',
            description: 'If this field is set content will redirect to requested internal article link (leave empty otherwise).',
        },
        {
            label: 'Source',
            name: 'source',
            input: 'select',
            description: 'Provider of this article.',
            options: [
                { label: 'Financial Finesse', value: 'Financial Finesse' },
                { label: 'OfColor', value: 'OfColor' },
            ],
        },
        {
            label: 'Paid Content',
            name: 'paidContent',
            input: 'select',
            description: 'Sets this article as a part of a paid selection of content from the source.',
            options: [
                { label: 'False', value: false },
                { label: 'True', value: true },
            ],
        },
        {
            label: 'Legacy ID',
            name: '_legacyId',
            input: 'number',
            disabled: true,
            description: 'Legacy ID for the document (if applicable).',
        },
        {
            label: 'Exclude from SmartBenefits',
            name: 'excludeFromSmartBenefits',
            input: 'select',
            description: 'Controls if this content should returned in SmartBenefits searches.',
            options: [
                { label: 'False', value: false },
                { label: 'True', value: true },
            ],
        },
    ],
    validate: [
        { property: 'title' },
        { property: 'slug' },
        { property: 'region' },
        { property: 'language' },
    ],
};
//# sourceMappingURL=articles.js.map